import { render, staticRenderFns } from "./lostPropertyReport.vue?vue&type=template&id=34aa0ee6"
import script from "./lostPropertyReport.vue?vue&type=script&lang=js"
export * from "./lostPropertyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports